import * as React from 'react';
import { SelectItem } from 'ui/common/select/types';
import { SelectionTypeProps } from '../../types';
import { SelectionType } from '../../types-fields';
import { mapToMenuItem, DropdownField } from 'app/area/reports/components/dropdown-field';
import { RadioSymbol } from 'ui';

import type { JSX } from "react";

type AggregateValueComponentProps = SelectionTypeProps

class AggregateValueComponent extends React.Component<AggregateValueComponentProps, {}> {
  private handleOnChange = () => {
    this.props.onChange({
      ...this.props.selectionField.value,
      level: this.props.selectionItem.levels ? this.props.selectionItem.levels[0] : undefined,
      type: SelectionType.AggregateValue
    });
  };

  private onClick = (level: SelectItem) => {
    this.props.onChange({
      ...this.props.selectionField.value,
      level: level
    });
  };

  public render(): JSX.Element {
    const {
      selectionField: {
        value
      },
      selectionItem,
      checked
    } = this.props;

    const selectedLevelOption = !!selectionItem.levels
      && !!value.level
      && mapToMenuItem(selectionItem.levels.find(l => l.value === value.level.value));
    const levelOptions = !!selectionItem.levels && selectionItem.levels.map(l => mapToMenuItem(l, () => this.onClick(l)));
    const uniqueId = `aggregate-value-${this.props.selectionField?.selectionNo}`;

    return (
      <>
        <input
          type="radio"
          className="form-check-input visuallyhidden"
          id={uniqueId}
          value={value.type}
          checked={checked}
          onChange={this.handleOnChange}
        />
        <label
          htmlFor={uniqueId}
          className="form-check-label">
          <RadioSymbol />
          {selectionItem.label}
        </label>

        {selectedLevelOption && <div className="input-wrapper"><DropdownField
          selectedItem={selectedLevelOption}
          options={levelOptions}
        /></div>}
      </>);
  }
}

export const AggregateValue = AggregateValueComponent;
